import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { InfoWindowTpl } from './infoWindow/infoWindowTpl';

const iconBase = GLOBAL_SCRIPTS.STATIC_VERSION + '/assets/images/gmaps';
const isSunParks = GLOBAL_SCRIPTS.UNIVERS.toUpperCase() === 'SP';

export const MapView = Backbone.View.extend({
  events: {
    'submit .gmapGeoLocation-form': 'geoLocationFormSubmit'
  },

  initialize: function (options) {
    this.setElement(options.element);
    this.$geolocationForm = $('.gmapGeoLocation-form');
    this.$addressInput = $('#gmapAddress');
    this.HasGeoLocation = this.$geolocationForm.length > 0;
    this.selectorId = options.mapSelectorId;
    this.$selectorId = $(`#${this.selectorId}`);
    this.model = options.model;
    this.markers = [];
    this.map = options.model.map;
    this.currentInfowindow = null;
    this.cacheWordings = GMAP_SCRIPTS.WORDING_SEARCH;
    this.domainListJsonUrl = options.domainListJsonUrl;
    this.$geoLocationMsg = $('.gmapGeoLocation-findMessageContent');
    this.$geoLocationAddress = $('#gmapGeoLocation-address');
    this.searchModel = options.searchModel;
    this.housingData = typeof options.housingParam !== 'undefined' ? options.housingParam : null;
    this.ajaxParams_default = {
      refresh: true,
      token: GMAP_SCRIPTS.SEARCH_TOKEN,
      c: GMAP_SCRIPTS.COLLECTION !== '' ? GMAP_SCRIPTS.COLLECTION : 'SEARCH_' + GLOBAL_SCRIPTS.UNIVERS.toUpperCase(),
      formats: '230x230,566x250',
      language: GLOBAL_SCRIPTS.LANGUAGE_CODE,
      market: GLOBAL_SCRIPTS.MARKET_CODE,
      _controller: GLOBAL_SCRIPTS.CONTROLLER,
      univers: GLOBAL_SCRIPTS.UNIVERS
    };

    if (this.housingData) {
      this.ajaxParams_default['facet[HOUSINGCATEGORY][]'] = this.housingData;
    }
    //used to display specific sites
    const complementaryParameters = typeof options.ajaxParams !== 'undefined' && options.ajaxParams !== null ? JSON.parse('{ "' + options.ajaxParams.replace(':', '" : "') + '" }') : {};
    this.paramSites = typeof complementaryParameters.sites !== 'undefined' ? complementaryParameters.sites.split(',') : false;

    if (GMAP_SCRIPTS.PROMOCODES !== '') {
      this.ajaxParams_default['facet[PROMOCODE][]'] = (GMAP_SCRIPTS.PROMOCODES + '').split(',');
    }

    if (GMAP_SCRIPTS.CONTROLLER === 'country') {
      this.ajaxParams_default.force_country = SEARCH_SCRIPTS.COUNTRY_CODE;
    } else if (GMAP_SCRIPTS.CONTROLLER === 'region') {
      this.ajaxParams_default.force_region = SEARCH_SCRIPTS.REGION_CODE;
    } else if (GMAP_SCRIPTS.CONTROLLER === 'destination') {
      this.ajaxParams_default.force_destination = SEARCH_SCRIPTS.DESTINATION_CODE;
    }

    // prends en compte les valeurs par defaut, et/ou les remplace
    this._config = this.model.get('config');
    this.iconsMarker = this.model.get('iconsMarker');
    this.gmapScriptLoad = false;
    this.$locationAlertContainer = $('#currentLocationAlert');

    if (typeof options.selectedProductCode !== 'undefined') {
      this.model.set('defaultProductCode', options.selectedProductCode);
    }

    //inactive la soumission du formulaire
    $('#js-gmapGeoLocation-form').on('submit', event => {
      event.preventDefault();
    });

    this.listenTo(dispatcher, 'gmap:updateUserLocation', this.updateUserLocation);
    this.listenTo(dispatcher, 'gmap:displayGeoLocation', this.displayGeoLocation);
    this.listenTo(dispatcher, 'gmap:alertDenyLocation', this.alertDenyLocation);
    this.listenTo(dispatcher, 'gmap:hightlightSpot', this.hightlightSpot);
    this.listenTo(dispatcher, 'gmap:refreshMap', this.refreshMap);

    this.openMap(this.ajaxParams_default);
  },

  //chargement de la gmap
  loadMap: function (ajaxParams_0 = {}) {

    if (typeof this.markers !== 'undefined') {
      this.removeMarkers(this.markers);
    }

    if (this.domainListJsonUrl !== '') {
      let datas = {};

      const successCallback = data => {
        if (data.status === 'success') {
          this.siteNumber = data.results.total;
          datas = data.results.results;
        } else {
          this.siteNumber = 0;
        }

        this.create({
          markers: datas
        });

        this.createResultList(datas);

        const self = this;
        setTimeout(function () {
          self.hightlightSpot(self.model.get('defaultProductCode'), true);
        }, 100);
      };

      dispatcher.trigger('search:searchModel:updateSearchParams', true);

      let ajaxParams = this.searchModel && Object.keys(this.searchModel.get('ajaxParametersCache')).length ? this.searchModel.get('ajaxParametersCache') : ajaxParams_0;
      ajaxParams['group'] = 'offer'; // toujours offer pour la gmap
      ajaxParams['option[formats_results]'] = '566x250,230x230';
      ajaxParams['accreditation'] = GLOBAL_SCRIPTS.ACCREDITATION;
      ajaxParams['accreditationGroup'] = GLOBAL_SCRIPTS.ACCREDITATION_GROUP;
      ajaxParams['cacheuser'] = GLOBAL_SCRIPTS.CACHE_USER;

      if (this.paramSites) {
        ajaxParams['facet[COUNTRYSITE][]'] = [];
        ajaxParams['country_site_referer[]'] = [];

        $.each(this.paramSites, function (index, item) {
          ajaxParams['facet[COUNTRYSITE][]'].push('l2_' + item);
          ajaxParams['country_site_referer[]'].push('l2_' + item);
        });
      }

      const ajaxDatas = {
        ajaxUrl: this.domainListJsonUrl,
        ajaxParams: ajaxParams,
        successCallback: successCallback,
        abortable: true,
        origin: 'gmap',
        type: 'GET',
        dataType: 'json'
      };

      if (this.gmapScriptLoad === false) {
        //on va chercher l'url signée
        const signedUrl = encodeURIComponent(encodeURI('/maps/api/js?client=gme-pierreetvacances&libraries=places&language=' + GLOBAL_SCRIPTS.LANGUAGE_CODE_REAL)).replace(/[!'()]/g, escape).replace(/\*/g, '%2A'),
          JSONSignature = GMAP_SCRIPTS.URL_SIGNATURE,
          ajaxParamsGmap = 'url=' + signedUrl;

        const successCallback_2 = callbackDatas => {

          $.getScript(
            '//maps.googleapis.com' + callbackDatas.results.data,
            function () {
              return genericAjaxCall(ajaxDatas);
            });

          this.gmapScriptLoad = true;
        };

        genericAjaxCall({
          ajaxUrl: JSONSignature,
          ajaxParams: ajaxParamsGmap,
          successCallback: successCallback_2,
          abortable: true,
          dataType: 'json',
          type: 'POST'
        });

      } else {
        return genericAjaxCall(ajaxDatas);
      }
    }
  },

  openMap: function (ajaxParams) {
    if (!this.model.get('isLoaded')) {
      loader.display('.popinContainer');

      if (typeof (ajaxParams) === 'undefined') {
        ajaxParams = this.ajaxParams_default;
      }

      this.loadMap(ajaxParams);
      this.model.set('isLoaded', true);

      setTimeout(function () {
        button.clearButtonLoader();
      }, 400);
    }
  },

  refreshMap: function (datas) {
    const housingMatch = datas.match(/'housing_code:(\d+)'/);
    const productCode = typeof datas.selectedProduct !== 'undefined' ? datas.selectedProduct : '';
    const complementaryParameters = typeof datas.ajaxParams !== 'undefined' ? JSON.parse('{ "' + datas.ajaxParams.replace(':', '" : "') + '" }') : {};

    let housingCode = housingMatch ? housingMatch[1] : null; // WPI-33173 refresh the housing code for ajaxparams
    let ajaxParams = this.searchModel && Object.keys(this.searchModel.get('ajaxParametersCache')).length ? this.searchModel.get('ajaxParametersCache') : this.ajaxParams_default;

    dispatcher.trigger('searchModel:updateSearchParams', true);
    ajaxParams['group'] = 'offer';
    ajaxParams['option[formats_results]'] = '566x250,230x230';

    if (housingCode) {
      ajaxParams['facet[HOUSINGCATEGORY][]'] = housingCode;
    }

    this.paramSites = typeof complementaryParameters.sites !== 'undefined' ? complementaryParameters.sites.split(',') : false;

    if (this.paramSites) {
      ajaxParams['facet[COUNTRYSITE][]'] = [];
      ajaxParams['country_site_referer[]'] = [];

      $.each(this.paramSites, function (_index, item) {
        ajaxParams['facet[COUNTRYSITE][]'].push('l2_' + item);
        ajaxParams['country_site_referer[]'].push('l2_' + item);
      });
    }

    loader.display('.popinContainer');

    const successCallback = data => {
      if (data.status === 'success') {
        this.siteNumber = data.results.total;
        const datas = data.results.results;

        this.refreshMarkers(datas);
        this.createResultList(datas);

        if (productCode !== '') {
          this.hightlightSpot(productCode, true);
        }
      }
    };

    const ajaxDatas = {
      ajaxUrl: this.domainListJsonUrl,
      ajaxParams: ajaxParams,
      successCallback: successCallback,
      abortable: true,
      origin: 'gmap',
      type: 'GET',
      dataType: 'json'
    };

    genericAjaxCall(ajaxDatas);

    //on vide le champ gmapAddress
    $('#gmapAddress').val('');

    //WPI-33173 fix the infinite loader
    setTimeout(function () {
      button.clearButtonLoader();
    }, 400);
  },

  hightlightSpot: function (productCode, displayInfoWindow = false) {
    this.model.set('defaultProductCode', productCode);

    //on met l'image over sur le spot
    $(this.markers).each((index, marker) => {
      if (marker.id === productCode) {
        marker.setIcon(this.iconsMarker['over']);

        if (displayInfoWindow) {
          const data = {
            latitude: marker.getPosition().lat(),
            longitude: marker.getPosition().lng()
          };

          this.openInfoWindow(data, productCode, marker);
        }
      } else {
        marker.setIcon(this.iconsMarker['regular']);
      }
    });

    //on surligne le container dans la liste
    $('.gmapResult-parkListContainer li').removeClass('highlighted');
    $('#gmapList-item-' + productCode).addClass('highlighted');
  },

  setMarkers: function (markers) {
    this.markers = [];
    this.opts = this.model.get('options');

    $.each(markers, (key, elt) => {
      // on appelle la fonction par rapport au nombre de marker
      this.setMarkerStore(key, elt);
    });

    if (this.opts.markersCluster) {
      const map = this.map;
      const markers = this.markers;

      this.mclusterer = new MarkerClusterer({map, markers,
        renderer: {
          render: ({ count, position }) => {
            return new google.maps.Marker({
              position,
              icon: {
                url: isSunParks ? `${iconBase}/cluster--SP.svg` : `${iconBase}/cluster.svg`,
                size: { width: 43, height: 43 },
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(43, 43),
                scaledSize: new google.maps.Size(43, 43),
                optimized: true
              },
              label: {
                text: String(count),
                color: '#3b4559',
                fontSize: '12px',
                fontWeight: 'bold'
              },
              zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count
            });
          }
        }
      });
    }

    //gestion du zoom automatique en fonction des markers
    if (Object.keys(markers).length > 1) {
      this.map.fitBounds(this.getBounds());
    } else if (Object.keys(this.markers).length === 1) {
      const key = Object.keys(markers)[0];

      this.map.setCenter(new google.maps.LatLng(markers[key].geo.lat, markers[key].geo.lon));
      this.map.setZoom(11);
    } else {
      this.map.setCenter(new google.maps.LatLng(0, 0));
      this.map.setZoom(2);
    }
  },

  // creation de la google maps
  // opts recupere les options d'affichage sur la google maps
  // markers, itineraire...etc
  create: function (opts) {
    this.opts = _.extend(this.model.get('options'), opts);
    this.styles = this.model.get('styles');
    this.map = new google.maps.Map(this.$selectorId.get(0), this._config);
    this.zoom = this.model.get('config').zoom;

    // Retrait des POI
    this.map.setOptions({styles: this.styles});
    this.markers = [];

    // si on souhaite afficher des markers sur la map
    // doit retourner un tableau

    if (this.opts.markers) {
      this.setMarkers(this.opts.markers);
    }

    //instanciation de l'autocomplete lié à la gmap
    if (this.HasGeoLocation) {
      this.initGmapAutocomplete();
      this.initGeoLocation();
    }

    this.initHideDomainCartouche();

    //fermeture de l'infowindow au clic n'importe ou sur la map
    google.maps.event.addListener(this.map, 'click', () => {
      if (this.currentInfowindow) {
        this.currentInfowindow.close();
      }
    });

    //trigger the redraw on resize
    google.maps.event.trigger(this.map, 'resize');
  },

  refreshMarkers(datas) {
    if (typeof this.map !== 'undefined') {
      // Retrait des POI
      if (typeof this.markers !== 'undefined') {
        this.removeMarkers(this.markers);
        this.mclusterer.clearMarkers();
      }

      //on créé les nouveaux markers
      this.setMarkers(datas);
    }
  },

  removeMarkers: function (arrMarkers) {
    for (let i = 0; i < arrMarkers.length; i++) {
      arrMarkers[i].setMap(null);
    }
  },

  //place un marker sur la gmap
  setMarkerStore: function (productCode, data) {
    const self = this;
    let iconType = this.model.get('defaultProductCode') === productCode ? 'over' : 'regular',
      label = 'domaine',
      iconWidth = 28,
      iconHeight = 48,
      anchorWidth = 14;

    const icon = {
      url: this.iconsMarker[iconType],
      size: new google.maps.Size(iconWidth, iconHeight),
      // The origin for this image is (0, 0).
      origin: new google.maps.Point(0, 0),
      // The anchor for this image is the base of the flagpole at (0, 36).
      anchor: new google.maps.Point(anchorWidth, iconHeight)
    };

    let marker = new google.maps.Marker({
      position: {
        lat: parseFloat(data.geo.lat),
        lng: parseFloat(data.geo.lon)
      },
      title: data.offer.name,
      type: label,
      icon,
      map: this.map,
      id: productCode
    });


    /* affichage infowindow */
    if (this.opts.infoWindow) {
      marker.addListener('click', () => {
        this.openInfoWindow(data, productCode, marker);

        Tracking.dataLayerPush({
          clickCode: 'clickOnGmap',
          gaCategory: PAGE_SCRIPTS.page_template,
          gaAction: 'gmap Pin',
          gaLabel: undefined,
          gaValue: 1,
          popinName: 'gmapInfoWindow',
          popinContainsFormInfos: false,
          event: 'popinDisplay'
        });
      });

      //gestion du hover
      marker.addListener('mouseover', () => {
        marker.setIcon(self.iconsMarker['over']);
      });

      marker.addListener('mouseout', () => {
        marker.setIcon(self.iconsMarker['regular']);
      });
    }

    this.markers.push(marker);
  },

  openInfoWindow: function (data, productCode, marker) {
    const $cartoucheMobile = $('#js-gmapMobileCartouche');

    let content;

    if (this.currentInfowindow) {
      this.currentInfowindow.close();
    }

    if (!DEVICE.isMobile) {
      data.wording = this.cacheWordings;
      data.staticUrl = GLOBAL_SCRIPTS.STATIC_VERSION;
      content = InfoWindowTpl(data);

      const infoWindow = new google.maps.InfoWindow({
        content: content,
        position: {
          lat: parseFloat(data.latitude),
          lng: parseFloat(data.longitude)
        },
        maxWidth: 500,
        top: 10
      });

      this.currentInfowindow = infoWindow;
      this.currentInfowindow.open(this.map, marker);

      //ajout d'un event touch pour corriger le bug ipad, qui ne réagit pas au click sur le bouton
      infoWindow.addListener('domready', () => {
        $(document).on('touchend', '.gmapInfoWindow-CTA', event => {
          event.preventDefault();
          window.location.href = event.currentTarget.href;
        });

        $(document).on('touchend', 'button.gm-ui-hover-effect', () => {
          this.currentInfowindow.close();
        });
      });

      google.maps.event.addListener(infoWindow, 'closeclick', function () {
        Tracking.dataLayerPush({
          clickCode: 'clickPopinExit',
          gaCategory: PAGE_SCRIPTS.page_template,
          gaAction: 'infoWindow',
          gaLabel: 'Explicite',
          gaValue: 1
        });
      });
    } else {
      this.map.setCenter(marker.getPosition());
      $cartoucheMobile.html($('#gmapList-item-' + productCode).html()).show();
    }
  },

  //cache l'éventuel cartouche de résultat sur mobile, au click sur la gmap
  initHideDomainCartouche: function () {
    if (DEVICE.isMobile) {
      this.map.addListener('click', () => {
        $('#js-gmapMobileCartouche').hide();
      });
    }
  },

  //met à jour la localisation utilisateur sur la gmap + enchainement actions liées
  updateUserLocation: function (geoLocation) {
    this.map = new google.maps.Map(this.$selectorId.get(0), this._config);
    this.model.set({'map': this.map});

    const markerLocation = new google.maps.LatLng(geoLocation.lat, geoLocation.long);
    const userLocation = this.model.get('userLocationMarker');
    const iconType = 'location';
    const label = this.cacheWordings.current_location_title;
    const iconWidth = 30;
    const iconHeight = 30;
    const anchorWidth = 15;
    const icon = {
      url: this.iconsMarker[iconType],
      size: new google.maps.Size(iconWidth, iconHeight),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(anchorWidth, iconHeight / 2)//because icon is target like, and has to be centered
    };
    const marker = new google.maps.Marker({
      position: markerLocation,
      title: label,
      icon,
      map: this.map
    });

    if (userLocation) {//s'il y a déjà un marker pour la localisation user
      let oldMarker = this.markers[userLocation];

      oldMarker.setMap(null);
      this.markers[userLocation] = marker;
    } else {
      this.markers.push(marker);
    }

    //mise à jour du modèle
    this.model.set('userLocationMarker', (this.markers.length - 1));
    this.map.setCenter(markerLocation);
    this.map.setZoom(7);

    //if there is no visible markers after the geolocation, we take a lower zoom
    google.maps.event.addListenerOnce(this.map, 'idle', () => {
      const nbVisibleMarkers = this.checkVisibleMarkers();

      if (nbVisibleMarkers < 2) {
        this.map.setZoom(6);
      }
    });

    //on ferme l'infowindow
    if (this.currentInfowindow) {
      this.currentInfowindow.close();
    }

    //mise à jour de la liste de résultat
    this.refreshResultList(geoLocation);

    if (typeof GMAP_SCRIPTS.CALLBACK !== 'undefined' && GMAP_SCRIPTS.CALLBACK !== '') {
      dispatcher.trigger(GMAP_SCRIPTS.CALLBACK, geoLocation);
    }

    setTimeout(function () {
      button.clearButtonLoader();
    }, 400);
  },

  checkVisibleMarkers() {
    let nbVisibleMarkers = 0;

    for (let i = 0; i < this.markers.length; i++) {
      if (this.map.getBounds().contains(this.markers[i].getPosition())) {
        nbVisibleMarkers++;
      }
    }

    return nbVisibleMarkers;
  },

  //defining bounds with all map markers
  getBounds() {
    let bounds = new google.maps.LatLngBounds();
    let latLng = {};

    $(this.markers).each((index, marker) => {
      latLng = marker.getPosition();
      bounds.extend(latLng);
    });

    return bounds;
  },

  /**
   * getTrackingDatasStringified : build string with all tracking parameters
   *
   * @params:
   *    @clickInfos : {object} {optional} => parameters for click trackin
   *    @actionAccommodationsInfos : {object} {optional} => parameters for the accommodation infos
   *
   **/
  getTrackingDatasStringified(params) {
    let trackingInfos;

    if (typeof params.clickInfos !== 'undefined') {
      trackingInfos = _.extend(params.clickInfos);

      //adding accommodations infos if any
      if (params.actionAccommodationsInfos) {
        const accommodationDatas = params.accommodationDatas;
        const accommodationsInfos = [{
          accommodationParkCountryCode: typeof accommodationDatas.country !== 'undefined' && typeof accommodationDatas.country.code !== 'undefined' ? accommodationDatas.country.code : undefined,//country code
          accommodationParkCountryName: typeof accommodationDatas.country !== 'undefined' && typeof accommodationDatas.country.name !== 'undefined' ? accommodationDatas.country.name : undefined,//country name
          accommodationShortSKU: typeof accommodationDatas.park !== 'undefined' && typeof accommodationDatas.park.code !== 'undefined' ? accommodationDatas.park.code : undefined,//product code
          accommodationSKU: typeof accommodationDatas.housing !== 'undefined' && typeof accommodationDatas.housing.code !== 'undefined' ? accommodationDatas.housing.code : undefined,//housing code
          accommodationName: typeof accommodationDatas.housing !== 'undefined' && typeof accommodationDatas.housing.name !== 'undefined' ? accommodationDatas.housing.name : undefined,//housing name
          accommodationRegionCode: typeof accommodationDatas.region !== 'undefined' && accommodationDatas.region.code !== 'undefined' ? accommodationDatas.region.code : undefined,//region code
          accommodationDestinationCode: typeof accommodationDatas.destination !== 'undefined' && typeof accommodationDatas.destination.code !== 'undefined' ? accommodationDatas.destination.code : undefined,// destination code
          accommodationParkCode: typeof accommodationDatas.park !== 'undefined' && typeof accommodationDatas.park.code !== 'undefined' ? accommodationDatas.park.code : undefined,//product code
          accommodationParkName: typeof accommodationDatas.park !== 'undefined' && typeof accommodationDatas.park.name !== 'undefined' ? accommodationDatas.park.name : undefined,//domain name
          accommodationType: typeof accommodationDatas.housing !== 'undefined' && typeof accommodationDatas.housing.type !== 'undefined' ? accommodationDatas.housing.type : undefined,//ex : tree house
          accommodationConfortType: typeof accommodationDatas.comfort !== 'undefined' && typeof accommodationDatas.comfort.name !== 'undefined' ? accommodationDatas.comfort.name : undefined,//comfort level name
          accommodationSeason: 'SUMMER',//season code
          accommodationBrand: typeof accommodationDatas.park !== 'undefined' && typeof accommodationDatas.park.code !== 'undefined' ? accommodationDatas.park.code !== 'VN' ? 'CP' : 'VN' : undefined,//BRAND code
          accommodationCapacity: typeof accommodationDatas.housing !== 'undefined' && typeof accommodationDatas.housing.capacity !== 'undefined' ? accommodationDatas.housing.capacity : undefined,//housing capacity
          accommodationHasOffer: false,//si offre spéciale
          accommodationAmountTF: undefined,//global price taxe free
          accommodationDiscountAmount: undefined,//reduction
          accommodationGrade: undefined,//trip advisor classement
          accommodationReviewsNumber: undefined,//trip advisor review
          accommodationPosition: undefined//position in the list displayed
        }];

        trackingInfos.actionAccommodationsInfos = true;
        trackingInfos.accommodationsInfos = accommodationsInfos;
      }
    }

    return JSON.stringify(trackingInfos);
  },

  createResultList(datas) {
    const wording = GMAP_SCRIPTS.WORDING_SEARCH;
    const wordingResult = GMAP_SCRIPTS.WORDING_RESULT;
    const deviceDatas = GLOBAL_SCRIPTS.DEVICE;
    const languageCode = GLOBAL_SCRIPTS.LANGUAGE_CODE_REAL;

    let n = 0;
    let resultList = '';

    $.each(datas, (key, item) => {
      const title = wordingResult.link_title_prefix + ' ' + item.offer.name; //'Voir la fiche '
      const srcDesktop = item.photo !== null && typeof item.photo['566x250'] !== 'undefined' ? GLOBAL_SCRIPTS.BASELINK_MEDIA + item.photo['566x250'][0] : GLOBAL_SCRIPTS.STATIC_VERSION + '/assets/images/default/566x250.jpg';
      const srcMobile = item.photo !== null && typeof item.photo['230x230'] !== 'undefined' ? GLOBAL_SCRIPTS.BASELINK_MEDIA + item.photo['230x230'][0] : GLOBAL_SCRIPTS.STATIC_VERSION + '/assets/images/default/230x230.jpg';
      const itemDistance = !!item.extra && !!item.extra.geo_distance ? parseInt(item.extra.geo_distance, 10) + ' km' : false;
      const htmlDistance = itemDistance ? `<p class="gmapListCartouche-distanceContainer u-Hidden-mobile"><span class="gmapListCartouche-distance">${itemDistance}</span> ${wording.distance_label}</p>` : '';
      const accommodationTrackingParams = {
        clickInfos: {
          'clickCode': 'clickOnGmap',
          'gaCategory': PAGE_SCRIPTS.page_template,
          'gaAction': 'gmapCartouche',
          'gaLabel': 'click on image',
          'gaValue': 1
        },
        actionAccommodationsInfos: true,
        accommodationDatas: {
          country: {
            code: typeof item.country.code !== 'undefined' ? item.country.code : undefined,
            name: typeof item.country.name !== 'undefined' ? item.country.name[languageCode] : ''
          },
          park: {
            code: item.offer.code,
            name: item.offer.name
          },
          housing: {
            code: undefined,
            name: undefined,
            capacity: undefined
          }
        }
      };

      const trackingInfosImage = this.getTrackingDatasStringified(accommodationTrackingParams);

      accommodationTrackingParams.clickInfos.gaLabel = 'click on text block';

      const trackingInfosText = this.getTrackingDatasStringified(accommodationTrackingParams);
      const countryName = item.country.name[languageCode];
      const urlOffer = GLOBAL_SCRIPTS.BASELINK + '/' + item.offer.url;

      const li = `<li id="gmapList-item-${key}">
        <div class="gmapListCartouche-container">
          <div class="gmapListCartouche r-Grid js-highlightSpot" data-code="${key}" data-id="${n}">
            <div class="r-Grid-cell r-all--1of3 r-minM--4of10 gmapListCartouche-imageContainer">
              <a href="${urlOffer}" title="${title}" class="u-img-rollover js-Tracking--link" data-tracking='${trackingInfosImage}'>
                <picture>
                  <source srcset="${srcMobile}" media="(max-width: ${deviceDatas.mediumScreen_maxWidth})">
                  <img class="lazy" src="${srcDesktop}" alt="${item.offer.name}" itemprop="image">
                </picture>
              </a>
            </div>
            <div class="r-Grid-cell r-all--2of3 r-minM--6of10 gmapListCartouche-text">
               <p class="gmapListCartouche-country">${countryName}</p>
               <p class="gmapListCartouche-label">${item.offer.name}</p>
               ${htmlDistance}
               <a href="${urlOffer}" class="gmapListCartouche-textLink js-Tracking--link" title="${title}" data-tracking='${trackingInfosText}'></a>
            </div>
          </div>
        </div>
      </li>`;
      resultList += li;
      n++;
    });

    $('.gmapResult-parkList').html(resultList);

    if (DEVICE.isDesktop) {
      //init highlight
      $('.js-highlightSpot').on('mouseover', event => {
        const spotId = $(event.currentTarget).data('code');
        const currMarker = this.markers.find(product => product.id === spotId);

        currMarker.setIcon(this.iconsMarker['over']);
      }).on('mouseout', event => {
        const spotId = $(event.currentTarget).data('code');
        const currMarker = this.markers.find(product => product.id === spotId);

        currMarker.setIcon(this.iconsMarker['regular']);
      });
    }

    loader.remove('.popinContainer');
  },

  //mise à jour de l'ordre de la liste de résultat grâce aux propriétés css flex, en fonction des distances entre les markers et la localisation utilisateur
  refreshResultList: function (geoLocation) {
    let ajaxParams = this.searchModel && Object.keys(this.searchModel.get('ajaxParametersCache')).length ? this.searchModel.get('ajaxParametersCache') : this.ajaxParams_default;

    dispatcher.trigger('searchModel:updateSearchParams', true);
    ajaxParams.group = 'offer';
    ajaxParams.user_geo_lat = geoLocation.lat;
    ajaxParams.user_geo_lon = geoLocation.long;
    ajaxParams.sort = 'distance';
    ajaxParams['option[formats_results]'] = '566x250,230x230';

    const successCallback = callbackData => {
      if (callbackData.status === 'success') {
        const datas = callbackData.results.results;

        this.createResultList(datas);
      }
    };

    return genericAjaxCall({
      ajaxUrl: this.domainListJsonUrl,
      ajaxParams: ajaxParams,
      successCallback: successCallback,
      abortable: true,
      origin: 'gmap',
      type: 'GET',
      dataType: 'json'
    });
  },

  //recupère la localisation géographique de l'utilisateur
  getLocation: function () {
    if (navigator.geolocation) {
      if (cookieManagement.getCookie('userLocation') === null) {
        navigator.geolocation.getCurrentPosition(this.geoSuccess, this.geoError);
      } else {
        //si user location mémorisée dans cookie,on reconstruit un objet geoloc avec les valeurs du cookie
        const cookieUserLocation = JSON.parse(cookieManagement.getCookie('userLocation'));
        const geoloc = {
          coords: {
            latitude: cookieUserLocation.lat,
            longitude: cookieUserLocation.long
          }
        };

        this.geoSuccess(geoloc);
      }
    }

    this.testUserLocation();
  },

  testUserLocation: function () {
    if (cookieManagement.getCookie('userDenyLocation')) {
      this.$locationAlertContainer.html(this.cacheWordings.gmap_location_alert_deny);
      this.$locationAlertContainer.show();
    } else {
      this.$locationAlertContainer.html('');
      this.$locationAlertContainer.hide();
    }
  },

  geoSuccess: function (geoloc) {
    //ajout du marker sur la map et mémorisation dans le modèle
    const geoLocation = {
      lat: geoloc.coords.latitude,
      long: geoloc.coords.longitude
    };

    cookieManagement.eraseCookie('userDenyLocation');
    $('#currentLocationAlert').html('');
    dispatcher.trigger('gmap:updateUserLocation', geoLocation);
  },

  geoError: function (error) {
    const cacheWordings = GMAP_SCRIPTS.WORDING_SEARCH;

    if (error.code === 1) {
      $('#currentLocationAlert').html(cacheWordings.gmap_location_alert_deny);
      cookieManagement.createCookie('userDenyLocation', true);
    } else {
      $('#currentLocationAlert').html(cacheWordings.gmap_location_alert_error);
    }
  },

  //instanciation des comportements du formulaire de géolocalisation
  initGeoLocation: function () {
    //instanciation du current location
    $('.js-gmapSearchCurrentLocation').on('click', () => {

      //if user already located
      if (cookieManagement.getCookie('userLocation')) {
        this.displayGeoLocation();
      } else {
        geoloc.init('gmap:displayGeoLocation', 'gmap:alertDenyLocation');
      }
    });

    //instantiation de la recherche par addresse
    $('.js-gmapAddressSubmit').on('click', () => {
      const address = $('#gmapAddress').val();

      this.getGeoLocation(address);
    });
  },

  displayGeoLocation: function () {
    this.getLocation();
    this.$addressInput.val('');
    this.$geoLocationMsg.hide();
    this.$locationAlertContainer.hide();
  },

  alertDenyLocation: function () {
    this.$locationAlertContainer.html(this.cacheWordings.gmap_location_alert_deny);
    this.$locationAlertContainer.show();
  },

  //récupère les coordonnées gps d'une adresse
  getGeoLocation: function (address) {
    const self = this;
    const addressEncoded = address.replace(/ /g, '+');

    //la gestion de la création de la signature par le biais d'un bypass json nécessite d'encoder l'intégralité des informations envoyées au json
    const geocodeUrlForSignature = encodeURIComponent(encodeURI(`/maps/api/geocode/json?address=${addressEncoded}&language=${GLOBAL_SCRIPTS.LANGUAGE_CODE_REAL}&client=gme-pierreetvacances`)).replace(/[!'()]/g, escape).replace(/\*/g, '%2A');
    const urlSignature = GMAP_SCRIPTS.URL_SIGNATURE;

    const successCallback = function (callBackData) {
      if (callBackData.status === 'success') {
        const geocodeUrl = `https://maps.googleapis.com${callBackData.results.data}`;
        const geocodeSuccess = function (geocodeData) {
          if (geocodeData.results.length) {
            const geoLocation = {
              lat: geocodeData.results[0].geometry.location.lat,
              long: geocodeData.results[0].geometry.location.lng
            };
            dispatcher.trigger('gmap:updateUserLocation', geoLocation);
            self.$geoLocationAddress.html(geocodeData.results[0].formatted_address);
            self.$geoLocationMsg.show();
          }

          setTimeout(function () {
            button.clearButtonLoader();
          }, 200);
        };

        genericAjaxCall({
          ajaxUrl: geocodeUrl,
          ajaxParams: null,
          successCallback: geocodeSuccess,
          abortable: true,
          dataType: 'json',
          type: 'GET'
        });
      }
    };

    genericAjaxCall({
      ajaxUrl: urlSignature,
      ajaxParams: `url=${geocodeUrlForSignature}`,
      successCallback: successCallback,
      abortable: true,
      dataType: 'json',
      type: 'POST'
    });
  },

  //inactivation de la soumission du formulaire
  geoLocationFormSubmit: function (event) {
    event.preventDefault();
  },

  //instanciation de l'autocomplete sur le focus dans champ qui permet de remplir son adresse
  initGmapAutocomplete: function () {
    $('#gmapAddress').on('focus', () => {
      this.loadGmapAutoComplete();
    });
  },

  //creation de l'objet places.autocomplete pour l'adresse
  loadGmapAutoComplete: function () {
    const geoCodeInput = $('#gmapAddress').get(0);

    let autocomplete = new google.maps.places.Autocomplete(geoCodeInput);

    autocomplete.bindTo('bounds', this.map);

    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();

      if (place.geometry) {//cas où l'utilisateur clique sur un des choix proposés par l'autocomplete
        const geoLocation = {
          lat: place.geometry.location.lat(),
          long: place.geometry.location.lng()
        };

        dispatcher.trigger('gmap:updateUserLocation', geoLocation);
        this.$geoLocationMsg.hide();
      } else {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        return false;
      }
    });

    //inactivation de la soumission du champ via la touche enter
    $(geoCodeInput).on('keypress', (event) => {
      if (event.which === 13) {
        event.preventDefault();
      }
    });
  }

});